



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import io from 'socket.io-client';
// import toast, { ToastContainer } from 'react-toastify';
// const Notifications = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [selectedNotification, setSelectedNotification] = useState(null); // State for modal
//   const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility
//   const navigate = useNavigate();
//   const socket = io(process.env.REACT_APP_API_URL.replace('http', 'ws'));

//   useEffect(() => {
//     fetchNotifications();

//     socket.on('newNotification', (notification) => {
//       setNotifications((prev) => [notification, ...prev]);
//     });

//     socket.on('notificationUpdated', (updatedNotification) => {
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === updatedNotification._id ? updatedNotification : n))
//       );
//     });

//     return () => socket.disconnect();
//   }, []);

//   const fetchNotifications = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/notifications`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       setNotifications(res.data);
//     } catch (err) {
//       console.error('Error fetching notifications:', err);
//     }
//   };

//   const handleMarkRead = async (id) => {
//     try {
//       await axios.put(`${process.env.REACT_APP_API_URL}oosh/service/notifications/${id}/read`, {}, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       fetchNotifications(); // Refresh list
//     } catch (err) {
//       console.error('Error marking as read:', err);
//     }
//   };

//   const handleViewDetails = (notification) => {
//     setSelectedNotification(notification);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedNotification(null);
//   };

//   const handleNavigate = (notification) => {
//     closeModal();
//     if (notification.type === 'booking_request' && notification.serviceId) {
//       navigate(`/service/${notification.serviceId}`);
//     } else if (notification.serviceId) {
//       navigate(`/post/${notification.serviceId}`);
//     }
//   };

//   // Calculate unread notifications
//   const unreadCount = notifications.filter((n) => !n.read).length;

//   // Helper to format client name
//   const getClientName = (serviceId) => {
//     if (serviceId?.clientId?.firstName || serviceId?.clientId?.lastName) {
//       return `${serviceId.clientId.firstName || ''} ${serviceId.clientId.lastName || ''}`.trim();
//     }
//     return 'A user';
//   };

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
//       <div className="flex items-center mb-6">
//         <h2 className="text-2xl font-bold text-blue-600">Notifications</h2>
//         {unreadCount > 0 && (
//           <span className="ml-2 bg-red-500 text-white text-xs font-semibold px-2.5 py-0.5 rounded-full">
//             {unreadCount}
//           </span>
//         )}
//       </div>
//       {notifications.length === 0 ? (
//         <p className="text-gray-500">No notifications yet.</p>
//       ) : (
//         <div className="space-y-4">
//           {notifications.map((notification) => (
//             <div
//               key={notification._id}
//               className={`p-4 border rounded-lg ${notification.read ? 'bg-gray-50' : 'bg-blue-50'}`}
//             >
//               <div className="flex justify-between items-start">
//                 <div>
//                   <p className="text-gray-800">
//                     {notification.message.replace(
//                       /undefined undefined/,
//                       getClientName(notification.serviceId)
//                     )}
//                   </p>
//                   {notification.serviceId && (
//                     <p className="text-sm text-gray-500">
//                       Related: {notification.serviceId.title || 'Service/Post'}
//                       {notification.serviceId.status && ` (Status: ${notification.serviceId.status})`}
//                     </p>
//                   )}
//                   <p className="text-xs text-gray-400">
//                     {new Date(notification.createdAt).toLocaleString()}
//                   </p>
//                 </div>
//                 {!notification.read && (
//                   <button
//                     onClick={() => handleMarkRead(notification._id)}
//                     className="ml-4 text-blue-500 hover:text-blue-700"
//                   >
//                     Mark as Read
//                   </button>
//                 )}
//               </div>
//               <button
//                 onClick={() => handleViewDetails(notification)}
//                 className="mt-2 text-green-500 hover:text-green-700"
//               >
//                 View Details
//               </button>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Modal for Notification Details */}
//       {isModalOpen && selectedNotification && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
//             <h3 className="text-xl font-semibold mb-4 text-blue-600">Notification Details</h3>
//             <div className="space-y-2">
//               <p className="text-gray-800">
//                 <span className="font-semibold">Message:</span>{' '}
//                 {selectedNotification.message.replace(
//                   /undefined undefined/,
//                   getClientName(selectedNotification.serviceId)
//                 )}
//               </p>
//               {selectedNotification.serviceId && (
//                 <>
//                   <p className="text-gray-600">
//                     <span className="font-semibold">Related:</span>{' '}
//                     {selectedNotification.serviceId.title || 'Service/Post'}
//                   </p>
//                   {selectedNotification.serviceId.status && (
//                     <p className="text-gray-600">
//                       <span className="font-semibold">Status:</span>{' '}
//                       {selectedNotification.serviceId.status}
//                     </p>
//                   )}
//                   {selectedNotification.serviceId.clientId && (
//                     <p className="text-gray-600">
//                       <span className="font-semibold">Posted by:</span>{' '}
//                       {getClientName(selectedNotification.serviceId)}
//                     </p>
//                   )}
//                 </>
//               )}
//               <p className="text-gray-600">
//                 <span className="font-semibold">Date:</span>{' '}
//                 {new Date(selectedNotification.createdAt).toLocaleString()}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Type:</span> {selectedNotification.type || 'N/A'}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Read:</span>{' '}
//                 {selectedNotification.read ? 'Yes' : 'No'}
//               </p>
//             </div>
//             <div className="mt-6 flex justify-end space-x-2">
//               {selectedNotification.serviceId && (
//                 <button
//                   onClick={() => handleNavigate(selectedNotification)}
//                   className="py-2 px-4 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all"
//                 >
//                   Go to {selectedNotification.type === 'booking_request' ? 'Service' : 'Post'}
//                 </button>
//               )}
//               <button
//                 onClick={closeModal}
//                 className="py-2 px-4 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-all"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default Notifications;






// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import io from 'socket.io-client';
// import { toast } from 'sonner';
// const Notifications = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [selectedNotification, setSelectedNotification] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const navigate = useNavigate();
//  const socket = io(process.env.REACT_APP_API_URL.replace('http', 'ws'));

//   useEffect(() => {
//     fetchNotifications();

//     socket.on('newNotification', (notification) => {
//       setNotifications((prev) => [notification, ...prev]);
//     });

//     socket.on('notificationUpdated', (updatedNotification) => {
//       setNotifications((prev) =>
//         prev.map((n) => (n._id === updatedNotification._id ? updatedNotification : n))
//       );
//     });

//     socket.on('bookingRequest', (data) => {
//       setNotifications((prev) => [
//         {
//           _id: data.notificationId,
//           message: `${data.providerName} has requested to book your post`,
//           type: 'booking_request',
//           serviceId: data.serviceId,
//           read: false,
//           createdAt: new Date(),
//         },
//         ...prev,
//       ]);
//     });

//     return () => {
//       socket.off('newNotification');
//       socket.off('notificationUpdated');
//       socket.off('bookingRequest');
//       socket.disconnect();
//     };
//   }, []);

//   const fetchNotifications = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/notifications`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       setNotifications(res.data);
//     } catch (err) {
//       console.error('Error fetching notifications:', err);
//     }
//   };

//   const handleMarkRead = async (id) => {
//     try {
//       await axios.put(`${process.env.REACT_APP_API_URL}oosh/service/notifications/${id}/read`, {}, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       fetchNotifications();
//     } catch (err) {
//       console.error('Error marking as read:', err);
//     }
//   };

//   const handleViewDetails = (notification) => {
//     setSelectedNotification(notification);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedNotification(null);
//   };

//   const handleNavigate = (notification) => {
//     closeModal();
//     if (notification.type === 'booking_request' && notification.serviceId) {
//       // Fetch the service to get the associated postId
//       axios.get(`${import.meta.env.VITE_API_URL}oosh/service/${notification.serviceId}`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       })
//         .then((res) => {
//           const postId = res.data.postId;
//           navigate(`/post/${postId}/providers`);
//         })
//         .catch((err) => {
//           console.error('Error fetching service:', err);
//           toast.error('Error navigating to service providers', {
//             style: { background: '#F44336', color: 'white' },
//           });
//         });
//     } else if (notification.serviceId) {
//       navigate(`/post/${notification.serviceId}`);
//     }
//   };

//   const unreadCount = notifications.filter((n) => !n.read).length;

//   const getClientName = (serviceId) => {
//     if (serviceId?.clientId?.firstName || serviceId?.clientId?.lastName) {
//       return `${serviceId.clientId.firstName || ''} ${serviceId.clientId.lastName || ''}`.trim();
//     }
//     return 'A user';
//   };

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
//       <div className="flex items-center mb-6">
//         <h2 className="text-2xl font-bold text-blue-600">Notifications</h2>
//         {unreadCount > 0 && (
//           <span className="ml-2 bg-red-500 text-white text-xs font-semibold px-2.5 py-0.5 rounded-full">
//             {unreadCount}
//           </span>
//         )}
//       </div>
//       {notifications.length === 0 ? (
//         <p className="text-gray-500">No notifications yet.</p>
//       ) : (
//         <div className="space-y-4">
//           {notifications.map((notification) => (
//             <div
//               key={notification._id}
//               className={`p-4 border rounded-lg ${notification.read ? 'bg-gray-50' : 'bg-blue-50'}`}
//             >
//               <div className="flex justify-between items-start">
//                 <div>
//                   <p className="text-gray-800">
//                     {notification.message.replace(
//                       /undefined undefined/,
//                       getClientName(notification.serviceId)
//                     )}
//                   </p>
//                   {notification.serviceId && (
//                     <p className="text-sm text-gray-500">
//                       Related: {notification.serviceId.title || 'Service/Post'}
//                       {notification.serviceId.status && ` (Status: ${notification.serviceId.status})`}
//                     </p>
//                   )}
//                   <p className="text-xs text-gray-400">
//                     {new Date(notification.createdAt).toLocaleString()}
//                   </p>
//                 </div>
//                 {!notification.read && (
//                   <button
//                     onClick={() => handleMarkRead(notification._id)}
//                     className="ml-4 text-blue-500 hover:text-blue-700"
//                   >
//                     Mark as Read
//                   </button>
//                 )}
//               </div>
//               <button
//                 onClick={() => handleViewDetails(notification)}
//                 className="mt-2 text-green-500 hover:text-green-700"
//               >
//                 View Details
//               </button>
//             </div>
//           ))}
//         </div>
//       )}

//       {isModalOpen && selectedNotification && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
//             <h3 className="text-xl font-semibold mb-4 text-blue-600">Notification Details</h3>
//             <div className="space-y-2">
//               <p className="text-gray-800">
//                 <span className="font-semibold">Message:</span>{' '}
//                 {selectedNotification.message.replace(
//                   /undefined undefined/,
//                   getClientName(selectedNotification.serviceId)
//                 )}
//               </p>
//               {selectedNotification.serviceId && (
//                 <>
//                   <p className="text-gray-600">
//                     <span className="font-semibold">Related:</span>{' '}
//                     {selectedNotification.serviceId.title || 'Service/Post'}
//                   </p>
//                   {selectedNotification.serviceId.status && (
//                     <p className="text-gray-600">
//                       <span className="font-semibold">Status:</span>{' '}
//                       {selectedNotification.serviceId.status}
//                     </p>
//                   )}
//                   {selectedNotification.serviceId.clientId && (
//                     <p className="text-gray-600">
//                       <span className="font-semibold">Posted by:</span>{' '}
//                       {getClientName(selectedNotification.serviceId)}
//                     </p>
//                   )}
//                 </>
//               )}
//               <p className="text-gray-600">
//                 <span className="font-semibold">Date:</span>{' '}
//                 {new Date(selectedNotification.createdAt).toLocaleString()}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Type:</span> {selectedNotification.type || 'N/A'}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Read:</span>{' '}
//                 {selectedNotification.read ? 'Yes' : 'No'}
//               </p>
//             </div>
//             <div className="mt-6 flex justify-end space-x-2">
//               {selectedNotification.serviceId && (
//                 <button
//                   onClick={() => handleNavigate(selectedNotification)}
//                   className="py-2 px-4 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all"
//                 >
//                   Go to {selectedNotification.type === 'booking_request' ? 'Providers' : 'Post'}
//                 </button>
//               )}
//               <button
//                 onClick={closeModal}
//                 className="py-2 px-4 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-all"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default Notifications;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const socket = io(process.env.REACT_APP_API_URL.replace('http', 'ws'));

  useEffect(() => {
    fetchNotifications();

    socket.on('newNotification', (notification) => {
      setNotifications((prev) => [notification, ...prev]);
    });

    socket.on('notificationUpdated', (updatedNotification) => {
      setNotifications((prev) =>
        prev.map((n) => (n._id === updatedNotification._id ? updatedNotification : n))
      );
    });

    socket.on('bookingRequest', (data) => {
      setNotifications((prev) => [
        {
          _id: data.notificationId,
          message: `${data.providerName} has requested to book your post`,
          type: 'booking_request',
          serviceId: data.serviceId,
          read: false,
          createdAt: new Date(),
        },
        ...prev,
      ]);
    });

    return () => {
      socket.off('newNotification');
      socket.off('notificationUpdated');
      socket.off('bookingRequest');
      socket.disconnect();
    };
  }, []);

  const fetchNotifications = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/notifications`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setNotifications(res.data);
    } catch (err) {
      console.error('Error fetching notifications:', err);
      toast.error('Error fetching notifications', {
        position: 'top-right',
        autoClose: 3000,
        style: { background: '#F44336', color: 'white' },
      });
    }
  };

  const handleMarkRead = async (id) => {
    try {
      await axios.put(`${process.env.REACT_APP_API_URL}oosh/service/notifications/${id}/read`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      fetchNotifications();
    } catch (err) {
      console.error('Error marking as read:', err);
      toast.error('Error marking notification as read', {
        position: 'top-right',
        autoClose: 3000,
        style: { background: '#F44336', color: 'white' },
      });
    }
  };

  const handleViewDetails = (notification) => {
    setSelectedNotification(notification);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedNotification(null);
  };

  const handleNavigate = (notification) => {
    closeModal();
    if (notification.type === 'booking_request' && notification.serviceId) {
      navigate('/my-posts/providers');
    } else if (notification.serviceId) {
      navigate(`/post/${notification.serviceId}`);
    }
  };

  const unreadCount = notifications.filter((n) => !n.read).length;

  const getClientName = (serviceId) => {
    if (serviceId?.clientId?.firstName || serviceId?.clientId?.lastName) {
      return `${serviceId.clientId.firstName || ''} ${serviceId.clientId.lastName || ''}`.trim();
    }
    return 'A user';
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <div className="flex items-center mb-6">
        <h2 className="text-2xl font-bold text-blue-600">Notifications</h2>
        {unreadCount > 0 && (
          <span className="ml-2 bg-red-500 text-white text-xs font-semibold px-2.5 py-0.5 rounded-full">
            {unreadCount}
          </span>
        )}
      </div>
      {notifications.length === 0 ? (
        <p className="text-gray-500">No notifications yet.</p>
      ) : (
        <div className="space-y-4">
          {notifications.map((notification) => (
            <div
              key={notification._id}
              className={`p-4 border rounded-lg ${notification.read ? 'bg-gray-50' : 'bg-blue-50'}`}
            >
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-gray-800">
                    {notification.message.replace(
                      /undefined undefined/,
                      getClientName(notification.serviceId)
                    )}
                  </p>
                  {notification.serviceId && (
                    <p className="text-sm text-gray-500">
                      Related: {notification.serviceId.title || 'Service/Post'}
                      {notification.serviceId.status && ` (Status: ${notification.serviceId.status})`}
                    </p>
                  )}
                  <p className="text-xs text-gray-400">
                    {new Date(notification.createdAt).toLocaleString()}
                  </p>
                </div>
                {!notification.read && (
                  <button
                    onClick={() => handleMarkRead(notification._id)}
                    className="ml-4 text-blue-500 hover:text-blue-700"
                  >
                    Mark as Read
                  </button>
                )}
              </div>
              <button
                onClick={() => handleViewDetails(notification)}
                className="mt-2 text-green-500 hover:text-green-700"
              >
                View Details
              </button>
            </div>
          ))}
        </div>
      )}

      {isModalOpen && selectedNotification && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
            <h3 className="text-xl font-semibold mb-4 text-blue-600">Notification Details</h3>
            <div className="space-y-2">
              <p className="text-gray-800">
                <span className="font-semibold">Message:</span>{' '}
                {selectedNotification.message.replace(
                  /undefined undefined/,
                  getClientName(selectedNotification.serviceId)
                )}
              </p>
              {selectedNotification.serviceId && (
                <>
                  <p className="text-gray-600">
                    <span className="font-semibold">Related:</span>{' '}
                    {selectedNotification.serviceId.title || 'Service/Post'}
                  </p>
                  {selectedNotification.serviceId.status && (
                    <p className="text-gray-600">
                      <span className="font-semibold">Status:</span>{' '}
                      {selectedNotification.serviceId.status}
                    </p>
                  )}
                  {selectedNotification.serviceId.clientId && (
                    <p className="text-gray-600">
                      <span className="font-semibold">Posted by:</span>{' '}
                      {getClientName(selectedNotification.serviceId)}
                    </p>
                  )}
                </>
              )}
              <p className="text-gray-600">
                <span className="font-semibold">Date:</span>{' '}
                {new Date(selectedNotification.createdAt).toLocaleString()}
              </p>
              <p className="text-gray-600">
                <span className="font-semibold">Type:</span> {selectedNotification.type || 'N/A'}
              </p>
              <p className="text-gray-600">
                <span className="font-semibold">Read:</span>{' '}
                {selectedNotification.read ? 'Yes' : 'No'}
              </p>
            </div>
            <div className="mt-6 flex justify-end space-x-2">
              {selectedNotification.serviceId && (
                <button
                  onClick={() => handleNavigate(selectedNotification)}
                  className="py-2 px-4 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all"
                >
                  Go to {selectedNotification.type === 'booking_request' ? 'Providers' : 'Post'}
                </button>
              )}
              <button
                onClick={closeModal}
                className="py-2 px-4 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-all"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Notifications;